<template>
  <div class="card plant-loader justify-content-center align-items-center" :style="{ height, background: '#2e4032' }">
    <svg class="plant-grow" viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg">
      <ellipse class="plant-soil" cx="50" cy="112" rx="26" ry="5"></ellipse>
      <g class="plant-sway">
        <path class="plant-stem" d="M50,110 Q46,86 50,60"></path>
        <path class="plant-leaf plant-leaf-left"
              d="M50,66 C37,64 26,55 28,43 C41,45 50,54 50,66 Z"></path>
        <path class="plant-leaf plant-leaf-right"
              d="M50,66 C63,64 74,55 72,43 C59,45 50,54 50,66 Z"></path>
        <circle class="plant-bud" cx="50" cy="58" r="3.2"></circle>
      </g>
    </svg>
    <p class="plant-loader-text">{{ text }}</p>
  </div>
</template>

<script>
// The same growing-plant loading animation used on the forest detail page
// (AreaItem.vue), pulled out into its own component so other list pages
// don't have to flash an empty table/state before their first data load.
export default {
  name: "PlantLoader",

  props: {
    text: {
      type: String,
      default: "Growing your data…"
    },
    height: {
      type: String,
      default: "320px"
    }
  }
};
</script>

<style scoped>
.plant-loader {
  flex-direction: column;
  gap: 14px;
}

.plant-grow {
  width: 104px;
  height: 124px;
  overflow: visible;
}

.plant-soil {
  fill: var(--border-subtle);
  opacity: 0.8;
}

.plant-sway {
  transform-box: fill-box;
  transform-origin: 50% 100%;
  animation: plant-sway 2.4s ease-in-out 0.75s infinite;
}

.plant-stem {
  fill: none;
  stroke: var(--accent-green);
  stroke-width: 4;
  stroke-linecap: round;
  stroke-dasharray: 60;
  stroke-dashoffset: 60;
  animation: plant-stem-grow 0.45s ease-out forwards;
}

.plant-leaf {
  opacity: 0;
  transform: scale(0);
  transform-box: fill-box;
  animation: plant-pop 0.3s ease-out forwards;
}

.plant-leaf-left {
  fill: var(--accent-green);
  transform-origin: 100% 100%;
  animation-delay: 0.3s;
}

.plant-leaf-right {
  fill: var(--accent-green-light);
  transform-origin: 0% 100%;
  animation-delay: 0.4s;
}

.plant-bud {
  fill: var(--accent-green-light);
  opacity: 0;
  transform: scale(0);
  transform-box: fill-box;
  transform-origin: 50% 50%;
  animation: plant-pop 0.25s ease-out 0.55s forwards;
}

.plant-loader-text {
  color: var(--text-muted);
  font-size: 0.9rem;
  letter-spacing: 0.02em;
}

@keyframes plant-stem-grow {
  to { stroke-dashoffset: 0; }
}

@keyframes plant-pop {
  0% { opacity: 0; transform: scale(0); }
  70% { opacity: 1; transform: scale(1.15); }
  100% { opacity: 1; transform: scale(1); }
}

@keyframes plant-sway {
  0%, 100% { transform: rotate(-2.5deg); }
  50% { transform: rotate(2.5deg); }
}
</style>
